var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon4",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(487.426 891.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33802",
    "data-name": "\\uD328\\uC2A4 33802",
    d: "M28.691,10.062l-1.433-.9-1.391-3.4A5.994,5.994,0,0,0,23.3,2.834L19.539.686a5.206,5.206,0,0,0-4.1-.461l-2.832.862L10.983.157A.671.671,0,0,0,10.439.1h0L10.428.1a.7.7,0,0,0-.244.143L.343,6A.677.677,0,0,0,0,6.6V8.978l.573,1.165a4.059,4.059,0,0,0,1.816,1.834l12.1,6.1,8.949,5.15a4.871,4.871,0,0,0,3.7.481A15.187,15.187,0,0,0,34.3,19.377a3.188,3.188,0,0,0,.846-2.17v-.76a20.927,20.927,0,0,0-6.457-6.385Zm0,0",
    transform: "translate(0)",
    fill: "#ed5100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33803",
    "data-name": "\\uD328\\uC2A4 33803",
    d: "M263.359,134.346l-1.433-.9-.584.343,5.7,7.489-4.9,2.711-9.729-4.957-.444.261,1.455.914a31.776,31.776,0,0,1,5.483,5.229,2.57,2.57,0,0,0,2.434.833,13.482,13.482,0,0,0,8.48-5.538,20.933,20.933,0,0,0-6.457-6.385Zm0,0",
    transform: "translate(-234.668 -124.284)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33804",
    "data-name": "\\uD328\\uC2A4 33804",
    d: "M23.433,119.138l-2.772-1.95A4.829,4.829,0,0,0,18.8,114.82c-1.247-.72-2.258.044-2.258,1.707a5.407,5.407,0,0,0,2.258,4.314,1.42,1.42,0,0,0,1.531.085Zm0,0",
    transform: "translate(-15.411 -106.685)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33805",
    "data-name": "\\uD328\\uC2A4 33805",
    d: "M254.734,251.549l-2.772-1.95a4.827,4.827,0,0,0-1.856-2.369c-1.247-.72-2.258.044-2.258,1.707a5.408,5.408,0,0,0,2.258,4.315,1.42,1.42,0,0,0,1.531.085Zm0,0",
    transform: "translate(-230.834 -230.006)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33806",
    "data-name": "\\uD328\\uC2A4 33806",
    d: "M26.669,101.309a2.571,2.571,0,0,1-2.434-.833,31.784,31.784,0,0,0-5.483-5.229L17.3,94.333l-1.391-3.4a5.991,5.991,0,0,0-2.572-2.932L9.579,85.858a5.206,5.206,0,0,0-4.1-.461l-2.832.862-1.626-.93A.683.683,0,0,0,0,85.922V88.3l.573,1.165A4.059,4.059,0,0,0,2.389,91.3l12.1,6.1,8.949,5.15a4.871,4.871,0,0,0,3.7.481A15.187,15.187,0,0,0,34.3,98.7a3.188,3.188,0,0,0,.846-2.17v-.76a13.483,13.483,0,0,1-8.48,5.537Zm0,0",
    transform: "translate(-0.001 -79.325)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33807",
    "data-name": "\\uD328\\uC2A4 33807",
    d: "M2.647,7.843,12.609,2l-1.626-.93a.671.671,0,0,0-.544-.057h0l-.01.005a.7.7,0,0,0-.244.143L.343,6.913A.677.677,0,0,0,0,7.506V9.887l.573,1.165a4.059,4.059,0,0,0,1.816,1.834l12.1,6.1,4.607,2.651V19.582Zm0,0",
    transform: "translate(0 -0.909)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33808",
    "data-name": "\\uD328\\uC2A4 33808",
    d: "M399.091,260.867v.9a16.377,16.377,0,0,1-6.568,4.116l-.981.316v-.964l1.553-.5a13.5,13.5,0,0,0,5.456-3.329Zm0,0",
    transform: "translate(-364.664 -242.958)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33809",
    "data-name": "\\uD328\\uC2A4 33809",
    d: "M252.364,251.544c0,1.663-1.011,2.427-2.258,1.707a5.407,5.407,0,0,1-2.258-4.314c0-1.663,1.011-2.427,2.258-1.707A5.407,5.407,0,0,1,252.364,251.544Zm0,0",
    transform: "translate(-230.834 -230.005)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33810",
    "data-name": "\\uD328\\uC2A4 33810",
    d: "M266.791,273.514c0,.818-.5,1.193-1.11.839a2.659,2.659,0,0,1-1.11-2.121c0-.818.5-1.193,1.11-.839A2.659,2.659,0,0,1,266.791,273.514Zm0,0",
    transform: "translate(-246.408 -252.637)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33811",
    "data-name": "\\uD328\\uC2A4 33811",
    d: "M273.174,283.239c0,.444-.27.647-.6.455a1.442,1.442,0,0,1-.6-1.151c0-.443.27-.647.6-.455A1.442,1.442,0,0,1,273.174,283.239Zm0,0",
    transform: "translate(-253.299 -262.656)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33812",
    "data-name": "\\uD328\\uC2A4 33812",
    d: "M21.063,119.138c0,1.663-1.011,2.427-2.258,1.707a5.408,5.408,0,0,1-2.258-4.315c0-1.663,1.011-2.427,2.258-1.707A5.407,5.407,0,0,1,21.063,119.138Zm0,0",
    transform: "translate(-15.412 -106.689)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33813",
    "data-name": "\\uD328\\uC2A4 33813",
    d: "M35.49,141.107c0,.818-.5,1.193-1.11.839a2.659,2.659,0,0,1-1.11-2.121c0-.818.5-1.193,1.11-.839A2.659,2.659,0,0,1,35.49,141.107Zm0,0",
    transform: "translate(-30.986 -129.32)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33814",
    "data-name": "\\uD328\\uC2A4 33814",
    d: "M41.873,150.831c0,.444-.27.647-.6.455a1.442,1.442,0,0,1-.6-1.15c0-.444.27-.647.6-.455A1.442,1.442,0,0,1,41.873,150.831Zm0,0",
    transform: "translate(-37.877 -139.337)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33815",
    "data-name": "\\uD328\\uC2A4 33815",
    d: "M239.8,93.23l8.933-5.244-1.362-3.233a.793.793,0,0,0-1.127-.379l-7.264,4.194a1.109,1.109,0,0,0-.478,1.367Zm0,0",
    transform: "translate(-222.055 -78.483)",
    fill: "#3b2f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33816",
    "data-name": "\\uD328\\uC2A4 33816",
    d: "M97.233,108.628l-1.219-3.235a2.861,2.861,0,0,0-1.222-1.455l-4.887-2.886a1.9,1.9,0,0,0-1.71-.113l-.756.32a.927.927,0,0,0-.1,1.656Zm0,0",
    transform: "translate(-80.912 -93.868)",
    fill: "#24170c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33817",
    "data-name": "\\uD328\\uC2A4 33817",
    d: "M326.9,87.737,325.679,84.5c-.025-.067-.054-.133-.084-.2a.785.785,0,0,0-.462.1l-2,1.157Zm0,0",
    transform: "translate(-300.947 -78.513)",
    fill: "#625951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33818",
    "data-name": "\\uD328\\uC2A4 33818",
    d: "M456.06,205.551a.469.469,0,0,0-.235.067l-.887.512-1.509.673,1.242,1.63a.4.4,0,0,0,.281.12.466.466,0,0,0,.235-.067l.887-.512a.914.914,0,0,0,.4-.747v-1.182A.444.444,0,0,0,456.06,205.551Zm0,0",
    transform: "translate(-422.303 -191.44)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33819",
    "data-name": "\\uD328\\uC2A4 33819",
    d: "M471.064,205.551a.469.469,0,0,0-.235.067l-.887.512a.913.913,0,0,0-.4.747v1.182a.443.443,0,0,0,.418.494.469.469,0,0,0,.235-.067l.887-.512a.915.915,0,0,0,.4-.747v-1.182A.444.444,0,0,0,471.064,205.551Zm0,0",
    transform: "translate(-437.306 -191.44)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33820",
    "data-name": "\\uD328\\uC2A4 33820",
    d: "M474.352,211.156l-.887.512c-.153.088-.278-.006-.278-.21v-1.182a.664.664,0,0,1,.278-.53l.887-.512c.153-.088.278.006.278.21v1.182A.664.664,0,0,1,474.352,211.156Zm0,0",
    transform: "translate(-440.705 -194.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33821",
    "data-name": "\\uD328\\uC2A4 33821",
    d: "M107.842,164.761l-7.416-4.846v2.68l7.416,3.984Zm0,0",
    transform: "translate(-93.533 -148.936)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33822",
    "data-name": "\\uD328\\uC2A4 33822",
    d: "M100.426,159.914l3.167,2.07-2.123-1.027v1.861l2.123,1.478-3.167-1.7Zm0,0",
    transform: "translate(-93.533 -148.936)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33823",
    "data-name": "\\uD328\\uC2A4 33823",
    d: "M350.791,262.6a.467.467,0,0,0-.235.067l-.887.512-2.068.922,1.8,1.38a.4.4,0,0,0,.282.121.467.467,0,0,0,.235-.067l.887-.512a.914.914,0,0,0,.4-.747V263.1A.444.444,0,0,0,350.791,262.6Zm0,0",
    transform: "translate(-323.739 -244.577)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33824",
    "data-name": "\\uD328\\uC2A4 33824",
    d: "M373.38,262.605a.467.467,0,0,0-.235.067l-.887.512a.914.914,0,0,0-.4.747v1.182a.444.444,0,0,0,.418.494.467.467,0,0,0,.235-.067l.887-.512a.913.913,0,0,0,.4-.747V263.1A.444.444,0,0,0,373.38,262.605Zm0,0",
    transform: "translate(-346.328 -244.577)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33825",
    "data-name": "\\uD328\\uC2A4 33825",
    d: "M376.672,268.214l-.887.512c-.153.089-.277-.006-.277-.21v-1.182a.665.665,0,0,1,.277-.53l.887-.512c.153-.088.277.006.277.21v1.182A.665.665,0,0,1,376.672,268.214Zm0,0",
    transform: "translate(-349.73 -247.98)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon4);
export default __webpack_public_path__ + "static/media/sec2Icon4.0308dd84472a2314991465bcdf22b323.svg";
export { ForwardRef as ReactComponent };